import { deviceType } from 'detect-it'

export default () => {
  const hasTouch = ref(false)
  const dT = ref(deviceType)

  onMounted(() => {
    hasTouch.value = deviceType !== 'mouseOnly'

    useResizeObserver(document.body, () => {
      dT.value = deviceType
      hasTouch.value = deviceType !== 'mouseOnly'
    })
  })

  return { hasTouch, deviceType: dT }
}
